import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
// import { onAuthStateChanged } from 'firebase/auth';
// import { httpsCallable } from 'firebase/functions';
// import { auth, functions } from '@/firebaseConfig';
import store from '@/store';
import sharedRoutes from './shared';
import adminRoutes from './admin';
import userRoutes from './user';

const routes: Array<RouteRecordRaw> = [
  ...sharedRoutes,
  ...adminRoutes,
  ...userRoutes,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// let userLoaded = false;

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  const user = store.getters.getCurrentUser;
  const isAuthenticated = !!user;

  if (requiresAuth && !isAuthenticated) {
    // Redirect to login if not authenticated
    console.log('Redirecting to login - user not authenticated');
    return next('/login');
  }

  if (isAuthenticated && to.path === '/') {
    // Redirect authenticated users to dashboard from root
    console.log('Redirecting to dashboard - user authenticated');
    return next('/dashboard');
  }

  // Continue with the navigation
  return next();
});

export default router;
